import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import api from "../api/api";
import List from "../List";
import functions from "../../functions/functions";
import moment from "moment/moment";
import FormGroup from "../form/FormGroup";
import Flows from "./Flows";
import TrashIcon from "../../icons/TrashIcon";
import GiftIcon from "../../icons/GiftIcon";
import GiftPopup from "./GiftPopup";
import Takeaway from "../../icons/Takeaway";
import Table from "../../icons/Table";
import Delivery from "../../icons/Delivery";
import HamburgerIcon from "../../icons/HamburgerIcon";
import NoteIcon from "../../icons/NoteIcon";
import BillIcon from "../../icons/BillIcon";
import PretotalIcon from "../../icons/PretotalIcon";
import SendIcon from "../../icons/SendIcon";
import DotIcon from "../../icons/DotIcon";
import ExpandIcon from "../../icons/ExpandIcon";
import CompressIcon from "../../icons/CompressIcon";
import SplitIcon from "../../icons/SplitIcon";
import FidelityDiscountIcon from "../../icons/FidelityDiscountIcon";
import DrawerIcon from "../../icons/DrawerIcon";
import MoveIcon from "../../icons/MoveIcon";
import MergeIcon from "../../icons/MergeIcon";
import TableDeliveryIcon from "../../icons/TableDeliveryIcon";
import MoveTableIconStrong from "../../icons/MoveTableIconStrong";
import { useAppStore } from "../../store/useAppStore";
import { filterNoteLines, parseAllergyFromNotes } from "../../utils/allergenFilter";

// etichette allergia della riga: righe nuove dal filtro attivo all'inserimento, righe salvate dalla nota
function lineAllergyLabels(prod) {
    if (!prod.item_id && prod.allergy_filter) return filterNoteLines(prod.allergy_filter);
    const parsed = parseAllergyFromNotes(prod.notes);
    const labels = [];
    if (parsed.allergy) labels.push("ALLERGIA: " + parsed.allergy);
    if (parsed.diet) labels.push("DIETA: " + parsed.diet);
    return labels;
}

function Cart() {
    const {
        allergenFilterEnabled,
        apiSettings,
        shop,
        fiscalPrinter,
        setEreciptPopup,
        calculateRoundForTotal,
        isErecipt,
        cart,
        setCart,
        editCart2,
        init_cart,
        setPopup,
        setConfirm,
        activeFlow,
        setEditingProduct,
        edited,
        setEdited,
        config,
        setSplitPopup,
        rooms,
        checkout,
        updateOrderFromCart,
        total,
        setTotal,
        deliveryPrice,
        setDeliveryPrice,
        checkPermission,
        hasPosPermission,
        askPermission,
        setOverlay,
        setPaymentPopup,
        points,
        pointsGained,
        setPointsGained,
        pointsSpent,
        setPointsSpent,
        setTableSelectorVisible,
        calculateTotal,
        loadOrders,
        loadSells,
        sendCommand,
    } = useContext(AppContext);
    const {
        splittedOrders,
        splittedOrdersCount,
        setSplittedOrders,
        setSplittedOrdersCount,
        totalBeforeRound,
    } = useAppStore();
    const [valid, setValid] = useState(false);
    const [error, setError] = useState(false);
    const [subMenuOpen, setSubMenuOpen] = useState(false);
    const hasProducts = cart?.products?.some((prod) => prod.flow == activeFlow) || false;
    const cartCustomerName = cart?.customer
        ? `${cart.customer.name || ""} ${cart.customer.surname || ""}`.trim()
        : `${cart?.name || ""} ${cart?.surname || ""}`.trim();
    const cartDoorphone = String(cart?.address?.doorphone ?? "").trim();

    useEffect(() => {
        if (cart) {
            check();
            calculateTotal();
            localStorage.setItem("pos-delivery_type", JSON.stringify(cart.delivery_type));
        }
    }, [cart, apiSettings]);

    useEffect(() => {
        calculatePoints();
    }, [total, cart, apiSettings]);

    const check = () => {
        console.log("check");
        let error = false;
        let passed = true;
        const hasCustomerData = Boolean(
            cart.customer || ((cart.name || "").trim() && (cart.surname || "").trim()),
        );

        if (!cart.shop_id) passed = false;
        if (cart.products.length == 0) {
            error = "Nessun prodotto";
            passed = false;
        }

        if (cart.delivery_type.id == "takeaway") {
            if (!cart.delivery_date) {
                error = "Manca la data di ritiro";
                passed = false;
            }
        }

        if (cart.delivery_type.id == "delivery") {
            if (
                !hasCustomerData &&
                cart.origin != "glovo" &&
                cart.origin != "deliveroo" &&
                cart.origin != "justeat"
            ) {
                error = "Manca il cliente";
                passed = false;
            } else if (!cart.address) {
                error = "Manca l'indirizzo";
                passed = false;
            } else if (!cart.delivery_date) {
                error = "Manca la data di consegna";
                passed = false;
            }
        }

        if (apiSettings.pos.mandatory_customer == 1 && !hasCustomerData) {
            error = "Manca il cliente";
            passed = false;
        }

        setValid(passed);
        setError(error);
    };

    const calculatePoints = () => {
        let points = 0;
        if (apiSettings.fidelity?.active == 1 && cart.customer && total > 0)
            points = parseInt(
                ((total - deliveryPrice) / apiSettings.fidelity.value) * apiSettings.fidelity.points,
            );
        setPointsGained(points);

        let points_spent = 0;
        for (const d of cart.discounts) {
            if (d.type == "fidelity") points_spent += parseInt(d.points);
        }
        setPointsSpent(points_spent);
    };

    const removeDiscount = (i) => {
        let nCart = { ...cart };
        nCart.discounts.splice(i, 1);
        setCart(nCart);
    };

    const generateCovers = () => {
        let res = [];
        for (let i = 1; i <= 20; i++) {
            res.push({ id: i, name: i });
        }
        return res;
    };

    const cancelOrder = async () => {
        if (checkPermission("orders", "archive")) {
            setConfirm({
                title: "Sei sicuro?",
                message: "Procedendo annullerai l'ordine corrente",
                onConfirm: async () => {
                    setSubMenuOpen(false);
                    setOverlay(false);
                    setSplittedOrders([]);
                    setSplittedOrdersCount(0);
                    init_cart();
                    const res = await api.postProtected("/orders/edit/" + cart.order_id + "/", {
                        status: "archived",
                    });
                    if (res.success == 0)
                        setConfirm({
                            title: "Errore",
                            message: res.error,
                        });
                    await Promise.allSettled([loadOrders(), loadSells()]);
                },
            });
        } else {
            askPermission();
        }
    };

    const printCopy = async () => {
        await api.postProtected("/orders/edit/" + cart.order_id + "/", {
            printed: 0,
        });
        await Promise.allSettled([loadOrders(), loadSells()]);
    };

    const isEditing = () => {
        //console.log("isEditing", cart);
        let res = false;
        if (cart.order_id) res = true;
        //console.log("isEditing", res);
        return res;
    };

    const remove = (i) => {
        setConfirm({
            title: "Sei sicuro?",
            message: "",
            onConfirm: async () => {
                let nCart = { ...cart };
                nCart.products.splice(i, 1);
                setCart(nCart);
                setEdited(true);
                setEditingProduct(false);
            },
        });
    };

    // Omaggio sulla riga (YELLGO-6114): la riga regalata va a price 0 e gift_price conserva il prezzo unitario,
    // che serve allo scontrino RT (rettifica "omaggio") e a rimettere il prezzo quando l'omaggio si toglie.
    const [giftPopup, setGiftPopup] = useState(null);

    const toggleGift = (i) => {
        const prod = cart.products[i];
        const run = () => {
            if (prod.gift) unsetGift(i);
            else if (parseInt(prod.qty) > 1) setGiftPopup({ i });
            else setGift(i, 1);
        };
        if (!prod.gift && !(parseFloat(prod.price) > 0)) {
            setConfirm({ title: "Omaggio non disponibile", message: "Il prodotto ha già prezzo 0." });
            return;
        }
        if (hasPosPermission("gifts", "edit", false)) run();
        else askPermission(run);
    };

    const setGift = (i, qty) => {
        const nCart = structuredClone(cart);
        const prod = nCart.products[i];
        const unitPrice = Math.round(parseFloat(prod.price) * 100) / 100;
        if (qty >= parseInt(prod.qty)) {
            prod.gift = 1;
            prod.gift_price = unitPrice;
            prod.price = 0;
        } else {
            // le unita' regalate diventano una riga nuova subito sotto
            prod.qty = parseInt(prod.qty) - qty;
            const giftLine = structuredClone(prod);
            delete giftLine.item_id;
            delete giftLine.uuid;
            giftLine.qty = qty;
            giftLine.gift = 1;
            giftLine.gift_price = unitPrice;
            giftLine.price = 0;
            if (prod.item_id) giftLine.split_from_id = prod.item_id;
            nCart.products.splice(i + 1, 0, giftLine);
        }
        setCart(nCart);
        setEdited(true);
        setGiftPopup(null);
    };

    const unsetGift = (i) => {
        const nCart = structuredClone(cart);
        const prod = nCart.products[i];
        prod.price = parseFloat(prod.gift_price) || 0;
        prod.gift = 0;
        prod.gift_price = null;
        delete prod.split_from_id;
        // se c'e' la stessa riga a pagamento la riunisco (2 tiramisu' + 1 omaggio -> 3 tiramisu'), tenendo quella gia' salvata
        const sameLine = (p) =>
            p !== prod &&
            !p.gift &&
            p.id == prod.id &&
            p.flow == prod.flow &&
            parseFloat(p.price) == prod.price &&
            (p.notes || "") == (prod.notes || "") &&
            JSON.stringify(p.variants_categories) == JSON.stringify(prod.variants_categories) &&
            JSON.stringify(p.ingredients) == JSON.stringify(prod.ingredients);
        const twin = nCart.products.find(sameLine);
        if (twin) {
            const [keep, drop] = !twin.item_id && prod.item_id ? [prod, twin] : [twin, prod];
            keep.qty = parseInt(keep.qty) + parseInt(drop.qty);
            nCart.products = nCart.products.filter((p) => p !== drop);
        }
        setCart(nCart);
        setEdited(true);
    };

    const showError = () => {
        setConfirm({
            title: "Errore",
            message: error,
        });
    };

    const getPointSale = () => {
        if (!cart.order_id) return parseInt(points);
        else {
            return parseInt(points) + Math.abs(parseInt(cart.pointsSpent)) - parseInt(cart.pointsGained);
        }
    };

    const handleOpenDrawer = () => {
        if (apiSettings.mandant.fiscal_printers != 1) return;
        if (typeof checkPermission === "function" && checkPermission("drawer_opening", "view")) {
            sendCommand("OPEN_DRAWER");
            return;
        }
        if (typeof askPermission === "function") {
            askPermission(() => sendCommand("OPEN_DRAWER"));
        }
    };

    const [pendingQuickPayment, setPendingQuickPayment] = useState(null);

    const quickPay = (paymentMethodId) => {
        if (!valid) {
            showError();
            return;
        }
        const finalTotal =
            paymentMethodId == 1
                ? Number(totalBeforeRound) + calculateRoundForTotal(Number(totalBeforeRound), true)
                : total;
        const amount = Number(finalTotal.toFixed(2));
        const payment = { payment_method_id: paymentMethodId, amount, o_amount: amount };

        setCart((prev) => ({ ...prev, payments: [payment] }));
        setPendingQuickPayment(payment);
    };

    useEffect(() => {
        if (!pendingQuickPayment) return;
        if (!cart.payments.includes(pendingQuickPayment)) return;

        setPendingQuickPayment(null);
        if (isErecipt()) {
            setEreciptPopup(true);
        } else if (isEditing()) {
            updateOrderFromCart(false, true, config.prebill_on_checkout == 1);
        } else {
            checkout(false, false, true, false, config.prebill_on_checkout == 1);
        }
    }, [cart, pendingQuickPayment]);

    const quickPaymentMethods = (config.quick_payment_method_ids || [])
        .filter((id) => id != null && id !== "")
        .map((id) => (shop?.payment_methods || []).find((m) => m.id == id))
        .filter(Boolean);

    if (!cart) return null;
    const cartRoomId = cart.room_id ?? cart.room?.id;

    return (
        <div className="cart">
            <div className="cart-box expand">
                <div className="cart-header">
                    <div className="cart-header-buttons-container">
                        <div className="cart-header-buttons">
                            <button>
                                {cart.delivery_type.id == "delivery" && <Delivery />}
                                {cart.delivery_type.id == "takeaway" && <Takeaway />}
                                {cart.delivery_type.id == "shop" && <Table />}
                            </button>
                            {cart.delivery_type && cart.table && (
                                <div className="label">
                                    <div className="">{cart.table.name}</div>
                                    <div className="small">{rooms.find((r) => r.id == cartRoomId)?.name}</div>
                                </div>
                            )}
                        </div>
                        <div className="cart-header-buttons">
                            <button
                                onClick={() => {
                                    setSubMenuOpen(false);
                                    setOverlay(false);
                                    setPopup({
                                        title: "Coperti",
                                        customClass: "covers-popup",
                                        content: (
                                            <List
                                                mode={3}
                                                elements={generateCovers()}
                                                onClick={(el) => {
                                                    setPopup(false);
                                                    editCart2({ covers: el.id });
                                                }}
                                            />
                                        ),
                                    });
                                }}
                            >
                                {cart.covers}
                            </button>

                            <button
                                onClick={() => {
                                    setSubMenuOpen(false);
                                    setOverlay(false);
                                    setTableSelectorVisible(cart);
                                }}
                            >
                                {cart.table ? <MoveTableIconStrong /> : <TableDeliveryIcon />}
                            </button>

                            {isEditing() && (
                                <>
                                    {!edited && (
                                        <button
                                            onClick={() => {
                                                setSubMenuOpen(false);
                                                setOverlay(false);
                                                setSplitPopup({
                                                    mode: "cart",
                                                    order: { ...cart, total: total },
                                                });
                                            }}
                                        >
                                            <SplitIcon />
                                        </button>
                                    )}
                                </>
                            )}

                            <button
                                onClick={() => {
                                    setSubMenuOpen(false);
                                    setOverlay(false);
                                    setPopup({
                                        title: "Note ordine",
                                        customClass: "order-notes-popup",
                                        content: (
                                            <div className="order-notes-popup-body">
                                                <FormGroup
                                                    type="textarea"
                                                    value={cart.notes}
                                                    onChange={(e) => {
                                                        editCart2({ notes: e.target.value });
                                                    }}
                                                />
                                                <button
                                                    type="button"
                                                    className="order-notes-insert-button"
                                                    onClick={() => setPopup(false)}
                                                >
                                                    Inserisci
                                                </button>
                                            </div>
                                        ),
                                    });
                                }}
                            >
                                <NoteIcon />
                            </button>
                            <div className="cart-submenu-container">
                                <button
                                    onClick={() => {
                                        setOverlay({
                                            action: () => {
                                                setSubMenuOpen(false);
                                                setOverlay(false);
                                            },
                                        });
                                        setSubMenuOpen(true);
                                    }}
                                >
                                    <HamburgerIcon />
                                </button>
                                {subMenuOpen && (
                                    <div className="cart-submenu">
                                        {isEditing() && (
                                            <>
                                                {!edited && (
                                                    <button
                                                        onClick={() => {
                                                            setSubMenuOpen(false);
                                                            setOverlay(false);
                                                            setSplitPopup({
                                                                mode: "cart",
                                                                order: { ...cart, total: total },
                                                            });
                                                        }}
                                                    >
                                                        Dividi
                                                    </button>
                                                )}
                                                {apiSettings.mandant.printers == 1 && (
                                                    <button
                                                        onClick={() => {
                                                            setConfirm({
                                                                title: "Stampare copia comande?",
                                                                message: "",
                                                                onConfirm: () => {
                                                                    console.log("here");
                                                                    setSubMenuOpen(false);
                                                                    setOverlay(false);
                                                                    printCopy();
                                                                },
                                                            });
                                                        }}
                                                    >
                                                        Ristampa comande
                                                    </button>
                                                )}
                                                <button onClick={() => cancelOrder()}>Archivia Ordine</button>
                                            </>
                                        )}
                                        <button
                                            onClick={() =>
                                                setConfirm({
                                                    title: "Sei sicuro?",
                                                    message: "",
                                                    onConfirm: () => {
                                                        setSubMenuOpen(false);
                                                        setOverlay(false);
                                                        setSplittedOrders([]);
                                                        setSplittedOrdersCount(0);
                                                        init_cart();
                                                    },
                                                })
                                            }
                                        >
                                            Nuovo Ordine
                                        </button>
                                        <button
                                            onClick={() => {
                                                setSubMenuOpen(false);
                                                setOverlay(false);
                                                setTableSelectorVisible(cart);
                                            }}
                                        >
                                            {cart.table ? <MoveTableIconStrong /> : <TableDeliveryIcon />}{" "}
                                            {cart.table ? "Cambia" : "Sposta su"} Tavolo
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                        {cartCustomerName && (
                            <div className="cart-customer-credit-box">
                                <div className="cart-customer-credit-name">
                                    <span className="cart-customer-credit-label">Cliente:</span>
                                    <strong>{cartCustomerName}</strong>
                                </div>
                                {apiSettings.credit?.active == 1 && cart.customer && (
                                    <div className="cart-customer-credit-balance">
                                        {functions.formatter.format(Number(cart.customer.credit) || 0)}
                                    </div>
                                )}
                            </div>
                        )}
                        {cart.address && cart.address.address && (
                            <div className="small">
                                Indirizzo: {cart.address.address} {cart.address.number}, {cart.address.city}
                                {cartDoorphone ? ` (${cartDoorphone})` : ""}
                            </div>
                        )}
                        {cart.delivery_date && (
                            <div className="small">
                                Data:{" "}
                                {moment(cart.delivery_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm")}
                            </div>
                        )}
                        {isEditing(cart) && <div className="small">Ordine {cart.order_id}</div>}
                        {splittedOrders.length > 0 && (
                            <div className="small alert-warning">
                                Ordine {splittedOrdersCount - splittedOrders.length + 1}{" "}
                                {" di " + splittedOrdersCount}
                            </div>
                        )}
                    </div>
                    <Flows />
                </div>
                <div className="scroll">
                    {!hasProducts && (
                        <div className="cart-empty-hint">Nessun prodotto presente nel carrello</div>
                    )}
                    {cart.products.map(
                        (prod, i) =>
                            prod.flow == activeFlow && (
                                <div
                                    key={i}
                                    className={
                                        "cart-product-line" +
                                        (prod.gift ? " gift" : "") +
                                        (allergenFilterEnabled && lineAllergyLabels(prod).length ? " allergen" : "")
                                    }
                                >
                                    <div className="cart-product-line-qty">{prod.qty}</div>
                                    <button
                                        className="cart-product-line-name"
                                        onClick={() => setEditingProduct({ i: i, data: prod })}
                                    >
                                        <div className="cart-product-name">{prod.name}</div>
                                        {allergenFilterEnabled &&
                                            lineAllergyLabels(prod).map((label, x) => (
                                                <div key={x} className="cart-product-allergy">
                                                    {label}
                                                </div>
                                            ))}
                                        <div className="small">
                                            {prod.variants_categories.map(
                                                (vc, n) =>
                                                    vc.selected > 0 && (
                                                        <div key={n}>
                                                            <div className="bold">{vc.name}</div>
                                                            {vc.variants.map(
                                                                (v, x) =>
                                                                    v.qty > 0 && (
                                                                        <div key={x}>
                                                                            {v.qty + "X " + v.name}
                                                                        </div>
                                                                    ),
                                                            )}
                                                            <Variants vc={vc} variants={vc.variants2} />
                                                            {vc.products.map(
                                                                (v, x) =>
                                                                    v.qty > 0 && (
                                                                        <div key={x}>
                                                                            {v.qty + "X " + v.name}
                                                                        </div>
                                                                    ),
                                                            )}
                                                            {vc.products2?.map(
                                                                (v, x) =>
                                                                    v.qty > 0 && (
                                                                        <div key={x}>
                                                                            {v.qty + "X " + v.name}
                                                                        </div>
                                                                    ),
                                                            )}
                                                        </div>
                                                    ),
                                            )}
                                            {allergenFilterEnabled &&
                                                !prod.item_id &&
                                                (prod.removed_defaults || []).map((name, x) => (
                                                    <div key={"rd" + x} className="cart-product-removed-default">
                                                        {"No " + name}
                                                    </div>
                                                ))}
                                            {prod.ingredients.map(
                                                (v, x) => v.removed && <div key={x}>{"No " + v.name}</div>,
                                            )}
                                        </div>
                                        {prod.notes && (
                                            <div className="small" style={{ whiteSpace: "pre-wrap" }}>
                                                <b>Note prodotto</b>
                                                <br />
                                                {prod.notes}
                                            </div>
                                        )}
                                        {prod.gift == 1 && (
                                            <div className="cart-product-gift-badge">
                                                <GiftIcon /> Omaggio
                                            </div>
                                        )}
                                    </button>
                                    <div key={i} className="cart-product-line-right">
                                        <div className="cart-product-line-price">
                                            {prod.gift == 1 && (
                                                <s className="cart-product-line-gift-price">
                                                    {functions.formatter.format(prod.gift_price * prod.qty)}
                                                </s>
                                            )}
                                            {functions.formatter.format(prod.price * prod.qty)}
                                        </div>
                                        <button
                                            className={"button button-2 square cart-gift-button" + (prod.gift ? " active" : "")}
                                            title={prod.gift ? "Togli omaggio" : "Omaggio"}
                                            onClick={() => toggleGift(i)}
                                        >
                                            <GiftIcon />
                                        </button>
                                        <button className="button button-2 square" onClick={() => remove(i)}>
                                            <TrashIcon />
                                        </button>
                                    </div>
                                </div>
                            ),
                    )}
                </div>
                {cart.discounts.map((d, i) => (
                    <div key={i} className="subtotal">
                        <div>
                            <button className="button-2" onClick={() => removeDiscount(i)}>
                                <TrashIcon />
                            </button>
                            <div>
                                {d.name +
                                    (d.value_type == "perc" || d.value_type == "percent"
                                        ? " " + Math.abs(d.value) + "%"
                                        : "")}
                            </div>
                        </div>
                        <div>
                            {d.price > 0 && "-"}
                            {functions.formatter.format(d.price > 0 ? d.price : -d.price)}
                        </div>
                    </div>
                ))}
                {deliveryPrice > 0 && (
                    <div className="subtotal">
                        <div>Consegna</div>
                        <div>{functions.formatter.format(deliveryPrice)}</div>
                    </div>
                )}
                {cart.credit_total > 0 && (
                    <div className="subtotal">
                        <div>Credito cliente</div>
                        <div>-{functions.formatter.format(cart.credit_total)}</div>
                    </div>
                )}
                <div>
                    <div className="total">
                        <div>Totale:</div>
                        <div className="total-price">{functions.formatter.format(totalBeforeRound)}</div>
                    </div>
                    <div
                        style={{
                            whiteSpace: "pre-wrap",
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                            gap: "5px",
                        }}
                    >
                        <div
                            className="small"
                            style={{
                                whiteSpace: "pre-wrap",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            <div
                                className={
                                    "payed-icon" +
                                    (cart.payment_method?.prepaid == 1 || cart.payments?.some(p => p.gateway) ? " text-success" : " text-error")
                                }
                            >
                                <DotIcon />
                            </div>
                            {cart.payment_method?.prepaid == 1 || cart.payments?.some(p => p.gateway) ? "Pagato" : "Non pagato"}
                        </div>
                        <div>
                            {apiSettings.fidelity?.active == 1 && cart && cart.customer && (
                                <div className="small">Saldo punti: {getPointSale()}</div>
                            )}
                            {pointsGained > 0 && (
                                <div className="small">Punti guadagnati: {pointsGained}</div>
                            )}
                            {pointsSpent > 0 && <div className="small">Punti spesi: {pointsSpent}</div>}
                        </div>
                    </div>
                </div>
                {cart.notes && (
                    <div className="small" style={{ whiteSpace: "pre-wrap" }}>
                        <b>Note Ordine</b>
                        <br />
                        {cart.notes}
                    </div>
                )}
            </div>
            <Keypad
                compact={config.quick_payment_footer == 1}
                quickPaymentMethods={quickPaymentMethods}
                quickPay={quickPay}
                handleOpenDrawer={handleOpenDrawer}
                saveButton={{
                    enabled: valid,
                    text: "Invia",
                    icon: <SendIcon />,
                    class: "bill",
                    action: () => {
                        if (valid) {
                            if (isEditing()) {
                                updateOrderFromCart();
                            } else {
                                if (config.optional_print == 1) {
                                    setConfirm({
                                        title: "Stampare comanda?",
                                        message: "",
                                        onConfirm: async () => {
                                            checkout(config.keep_open_after_checkout == 1);
                                        },
                                        onCancel: async () => {
                                            checkout(
                                                config.keep_open_after_checkout == 1,
                                                false,
                                                false,
                                                false,
                                                false,
                                                { printed: 1 },
                                            );
                                        },
                                    });
                                } else {
                                    checkout(config.keep_open_after_checkout == 1);
                                }
                            }
                        } else showError();
                    },
                }}
                preBillButton={{
                    enabled: valid,
                    text: "Preconto",
                    icon: <PretotalIcon />,
                    class: "bill",
                    action: () => {
                        if (valid) {
                            if (isEditing()) {
                                updateOrderFromCart(false, false, true);
                            } else {
                                checkout(config.keep_open_after_checkout == 1, false, false, false, true);
                            }
                        } else showError();
                    },
                }}
                billButton={{
                    enabled: valid,
                    text: "Completa",
                    icon: <BillIcon />,
                    class: "bill large",
                    action: () => {
                        if (valid) {
                            if (isEditing()) {
                                if (
                                    total == 0 ||
                                    (cart.payment_method?.prepaid == 1 &&
                                        config.skip_payment_request_for_payed == 1)
                                ) {
                                    updateOrderFromCart(false, true, config.prebill_on_checkout == 1);
                                } else {
                                    if (
                                        apiSettings.mandant.fiscal_printers == 1 ||
                                        apiSettings.mandant.fiskaly == 1 ||
                                        apiSettings.pos.fast_checkout == 0
                                    ) {
                                        setPaymentPopup(true);
                                    } else {
                                        updateOrderFromCart(false, true, config.prebill_on_checkout == 1);
                                    }
                                }
                            } else {
                                if (
                                    apiSettings.mandant.fiscal_printers == 1 ||
                                    apiSettings.mandant.fiskaly == 1 ||
                                    apiSettings.pos.fast_checkout != 1
                                ) {
                                    setPaymentPopup(true);
                                } else {
                                    checkout(false, false, true, false, config.prebill_on_checkout == 1);
                                }
                            }
                        } else showError();
                    },
                }}
            />
            {giftPopup && cart.products[giftPopup.i] && (
                <GiftPopup
                    product={cart.products[giftPopup.i]}
                    onConfirm={(qty) => setGift(giftPopup.i, qty)}
                    onClose={() => setGiftPopup(null)}
                />
            )}
        </div>
    );
}

function Variants({ vc, variants }) {
    const [sortedVariants, setSortedVariants] = useState([]);

    useEffect(() => {
        if (variants && Array.isArray(variants)) {
            const sorted = [...variants].sort((a, b) => {
                if (a.qty === 0 && b.qty !== 0) return -1;
                if (a.qty !== 0 && b.qty === 0) return 1;
                return 0;
            });
            setSortedVariants(sorted);
        }
    }, [vc]);

    return sortedVariants.map((v, x) => <Variant key={x} vc={vc} v={v} />);
}

function Variant({ vc, v }) {
    function getQtyLabel() {
        if (vc.force_mono == 1 && v.qty == 0) return "No ";
        else return v.qty + "X ";
    }

    if (v.qty == undefined) return null;
    if (v.qty == 0 && vc.force_mono == 0) return null;

    return <div className={v.qty <= 0 ? "text-error" : ""}>{getQtyLabel() + v.name}</div>;
}

function Keypad({
    billButton,
    preBillButton,
    saveButton,
    handleOpenDrawer,
    compact,
    quickPaymentMethods,
    quickPay,
}) {
    const {
        amount,
        setAmount,
        command,
        setCommand,
        cart,
        setCart,
        apiSettings,
        setFidelityDiscountsPopupVisible,
        sendCommand,
        user,
        askPermission,
    } = useContext(AppContext);
    const [open, setOpen] = useState(localStorage.getItem("pos-keypad-open") || true);
    const maxDiscount = user?.role?.max_discount != null ? parseFloat(user.role.max_discount) : null;

    useEffect(() => {
        if (amount == "") {
            setCommand(false);
        }
    }, [amount]);

    useEffect(() => {
        localStorage.setItem("pos-keypad-open", open);
    }, [open]);

    const addDiscount = () => {
        if (!amount) return;

        const buildDiscount = () => {
            const nCart = { ...cart, discounts: [...cart.discounts] };
            if (command == "") {
                nCart.discounts.push({
                    name: "Supplemento",
                    type: "fixed",
                    value_type: "fixed",
                    value: -parseFloat(amount),
                    user_id: user?.id,
                });
            }
            if (command == "minus") {
                nCart.discounts.push({
                    name: "Sconto cassa",
                    type: "fixed",
                    value_type: "fixed",
                    value: parseFloat(amount),
                    user_id: user?.id,
                });
            }
            if (command == "percminus") {
                nCart.discounts.push({
                    name: "Sconto cassa",
                    type: "perc",
                    value_type: "perc",
                    value: parseFloat(amount),
                    user_id: user?.id,
                });
            }
            if (command == "percplus") {
                nCart.discounts.push({
                    name: "Supplemento",
                    type: "perc",
                    value_type: "perc",
                    value: -parseFloat(amount),
                    user_id: user?.id,
                });
            }
            setCart(nCart);
            setAmount("");
            setCommand(false);
        };

        const existingFixed = cart.discounts
            .filter((d) => d.user_id != null && d.value_type === "fixed" && d.value > 0)
            .reduce((sum, d) => sum + d.value, 0);

        if (command === "minus" && maxDiscount !== null && existingFixed + parseFloat(amount) > maxDiscount) {
            askPermission(buildDiscount);
        } else {
            buildDiscount();
        }
    };

    const hasDiscountsFidelity = () => {
        return cart.discounts.find((d) => d.type == "fidelity");
    };

    if (compact) {
        return (
            <div className="keypad-compact">
                <div className="keypad-compact-actions">
                    {apiSettings.mandant.fiscal_printers == 1 && (
                        <button className="light" onClick={handleOpenDrawer}>
                            <div className="icon">
                                <DrawerIcon />
                            </div>
                        </button>
                    )}
                    <button
                        className={"bill" + (preBillButton.enabled === false ? " disabled" : "")}
                        onClick={preBillButton.action}
                    >
                        <div className="icon">{preBillButton.icon}</div>
                        {preBillButton.text}
                    </button>
                    <button
                        className={"bill large" + (billButton.enabled === false ? " disabled" : "")}
                        onClick={billButton.action}
                    >
                        <div className="icon">{billButton.icon}</div>
                        {billButton.text}
                    </button>
                    <button
                        className={"bill send" + (saveButton.enabled === false ? " disabled" : "")}
                        onClick={saveButton.action}
                    >
                        <div className="icon">{saveButton.icon}</div>
                    </button>
                </div>

                {quickPaymentMethods.length > 0 && (
                    <div className="quick-payment-section">
                        <div className="quick-payment-section-title">Pagamento rapido</div>
                        <div className="quick-payment-section-buttons">
                            {quickPaymentMethods.map((method) => (
                                <button
                                    key={method.id}
                                    className="quick-payment-button"
                                    onClick={() => quickPay(method.id)}
                                >
                                    <div className="icon">
                                        <img src={"/payments/" + method.id + ".png"} alt={method.name} />
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                )}

                <button className="keypad-compact-toggle" onClick={() => setOpen(!open)}>
                    Tastierino operazioni
                    {open ? <CompressIcon /> : <ExpandIcon />}
                </button>

                {open && (
                    <div className="keypad-compact-pad">
                        <div className="keypad-compact-pad-grid">
                            <div
                                className={
                                    "keypad-amount keypad-pad-total" +
                                    (apiSettings.fidelity?.active == 1 ? " fidelity-enabled" : "")
                                }
                            >
                                <div className="keypad-amount-number">{amount}</div>
                                <button
                                    onClick={() => setAmount(amount.substring(0, amount.length - 1))}
                                >
                                    &#60;
                                </button>
                            </div>
                            {[
                                { text: "7", class: "light", action: () => setAmount(amount + "7") },
                                { text: "8", class: "light", action: () => setAmount(amount + "8") },
                                { text: "9", class: "light", action: () => setAmount(amount + "9") },
                                { text: "4", class: "light", action: () => setAmount(amount + "4") },
                                { text: "5", class: "light", action: () => setAmount(amount + "5") },
                                { text: "6", class: "light", action: () => setAmount(amount + "6") },
                                { text: "€", class: "dark", action: () => addDiscount() },
                                apiSettings.fidelity?.active == 1
                                    ? {
                                          icon: <FidelityDiscountIcon />,
                                          class: "outline",
                                          enabled: !(!cart.customer || hasDiscountsFidelity()),
                                          action: () =>
                                              cart.customer &&
                                              !hasDiscountsFidelity() &&
                                              setFidelityDiscountsPopupVisible(true),
                                      }
                                    : null,
                                { text: "1", class: "light", action: () => setAmount(amount + "1") },
                                { text: "2", class: "light", action: () => setAmount(amount + "2") },
                                { text: "3", class: "light", action: () => setAmount(amount + "3") },
                                {
                                    text: "X",
                                    class: "dark",
                                    action: () => setCommand(command == "multi" ? false : "multi"),
                                    enabled: command == "multi",
                                },
                                {
                                    text: "-",
                                    class: "dark",
                                    action: () => setCommand(command == "minus" ? false : "minus"),
                                    enabled: command == "minus",
                                },
                                {
                                    text: "0",
                                    class: "light keypad-pad-zero",
                                    action: () => setAmount(amount + "0"),
                                },
                                { text: ".", class: "light", action: () => setAmount(amount + ".") },
                                {
                                    text: "%-",
                                    class: "outline",
                                    action:
                                        maxDiscount !== null
                                            ? () => askPermission(() => setCommand("percminus"))
                                            : () => setCommand(command == "percminus" ? false : "percminus"),
                                    enabled: command == "percminus",
                                },
                                {
                                    text: "%+",
                                    class: "outline",
                                    action: () => setCommand(command == "percplus" ? false : "percplus"),
                                    enabled: command == "percplus",
                                },
                            ]
                                .filter(Boolean)
                                .map((button, i) => (
                                    <button
                                        key={i}
                                        onClick={button.action}
                                        className={
                                            button.class + (button.enabled === false ? " disabled" : "")
                                        }
                                    >
                                        {button.icon && <div className="icon">{button.icon}</div>}
                                        {button.text}
                                    </button>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={"keypad" + (open ? " open" : " closed")}>
            <button className="expand-button" onClick={() => setOpen(open ? false : true)}>
                {open ? (
                    <>
                        <CompressIcon></CompressIcon>
                    </>
                ) : (
                    <>
                        <ExpandIcon></ExpandIcon>
                    </>
                )}
            </button>
            <div
                className={
                    "keypad-amount open-only" + (apiSettings.fidelity?.active == 1 ? " fidelity-enabled" : "")
                }
            >
                <div className="keypad-amount-number">{amount}</div>
                <button onClick={() => setAmount(amount.substring(0, amount.length - 1))}>&#60;</button>
            </div>
            {apiSettings.fidelity?.active == 1 && (
                <button
                    className={
                        "dark open-only" + (!cart.customer || hasDiscountsFidelity() ? " disabled" : "")
                    }
                    onClick={() =>
                        cart.customer && !hasDiscountsFidelity() && setFidelityDiscountsPopupVisible(true)
                    }
                >
                    <div className="icon">
                        <FidelityDiscountIcon />
                    </div>
                </button>
            )}
            {[
                { text: "€", class: "dark open-only", action: () => addDiscount() },
                saveButton,
                { text: "7", class: "light open-only", action: () => setAmount(amount + "7") },
                { text: "8", class: "light open-only", action: () => setAmount(amount + "8") },
                { text: "9", class: "light open-only", action: () => setAmount(amount + "9") },
                {
                    text: "X",
                    class: "dark open-only",
                    action: () => setCommand(command == "multi" ? false : "multi"),
                    enabled: command == "multi",
                },
                preBillButton,
                { text: "4", class: "light open-only", action: () => setAmount(amount + "4") },
                { text: "5", class: "light open-only", action: () => setAmount(amount + "5") },
                { text: "6", class: "light open-only", action: () => setAmount(amount + "6") },
                {
                    text: "-",
                    class: "dark open-only",
                    action: () => setCommand(command == "minus" ? false : "minus"),
                    enabled: command == "minus",
                },
                billButton,
                { text: "1", class: "light open-only", action: () => setAmount(amount + "1") },
                { text: "2", class: "light open-only", action: () => setAmount(amount + "2") },
                { text: "3", class: "light open-only", action: () => setAmount(amount + "3") },
                {
                    text: "%-",
                    class: "dark open-only",
                    action: maxDiscount !== null
                        ? () => askPermission(() => setCommand("percminus"))
                        : () => setCommand(command == "percminus" ? false : "percminus"),
                    enabled: command == "percminus",
                },
                { text: "0", class: "light open-only", action: () => setAmount(amount + "0") },
                { text: ".", class: "light open-only", action: () => setAmount(amount + ".") },
                {
                    icon: apiSettings.mandant.fiscal_printers == 1 ? <DrawerIcon /> : null,
                    class: "light open-only",
                    action: handleOpenDrawer,
                },
                {
                    text: "%+",
                    class: "dark open-only",
                    action: () => setCommand(command == "percplus" ? false : "percplus"),
                    enabled: command == "percplus",
                },
            ].map((button, i) => (
                <button
                    key={i}
                    onClick={button.action}
                    className={button.class + (button.enabled === false ? " disabled" : "")}
                >
                    {button.payed != undefined && (
                        <div className={"payed-icon" + (button.payed ? " text-success" : " text-error")}>
                            <DotIcon />
                        </div>
                    )}
                    {button.icon && <div className="icon">{button.icon}</div>}
                    {button.text}
                </button>
            ))}
        </div>
    );
}

export default Cart;
